<template>
	<div class="drawer">
		<el-drawer
		v-if="msg.recordId"
		size="80%"
		title="挂号详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:20px;">
				<el-row class="row">
					<el-col :span="6">
						<span class="label">顾客：</span>
						<span class="value">{{msg.memberName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">手机号：</span>
						<span class="value">{{msg.memberMobile}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="6">
						<span class="label">宠物：</span>
						<span class="value">{{msg.petName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">品种：</span>
						<span class="value">{{msg.typeName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">性别：</span>
						<span class="value">
							{{msg.sex}}
						</span>
					</el-col>
					<el-col :span="6">
						<span class="label">年龄：</span>
						<span class="value">
							{{$public.FAge(msg.birthDay)[0]}}岁 {{$public.FAge(msg.birthDay)[1]}}月
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="6">
						<span class="label">状态：</span>
						<span class="value">
							<span v-if="msg.status===1">待接诊</span>
							<span v-if="msg.status===2">已接诊</span>
							<span v-if="msg.status===3">已完成</span>
						</span>
					</el-col>
					<el-col :span="6">
						<span class="label">挂号时间：</span>
						<span class="value">
							{{$public.FTime(msg.createTime)}}
						</span>
					</el-col>
					<el-col :span="6">
						<span class="label">医生：</span>
						<span class="value">{{msg.doctorName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">销售人员：</span>
						<span class="value">{{msg.salesMans.join(" ")}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="6">
						<span class="label">备注：</span>
						<span class="value">{{msg.remark}}</span>
					</el-col>
				</el-row>
			</div>
			<div style="font-size: 16px;color: #333;padding-left:20px;padding-bottom:20px;">关联病例</div>
			<el-table :data="tableData" style="width:1200px;margin-left:0px;">
				<el-table-column label="编号" width="80">
					<template slot-scope="props">
						{{parseInt(props.$index+1)}}
					</template>
				</el-table-column>
				<el-table-column label="病例单号">
					<template slot-scope="props">
						<!-- <span class="biaoqianA" @click="toBingliSee(props.row.caseNumber)">{{props.row.caseNumber}}</span> -->
						{{props.row.caseNumber}}
					</template>
				</el-table-column>
				<el-table-column label="病例时间" width="200">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="添加时间" width="200">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="是否检测" width="150">
					<template slot-scope="props">
						<div style="color:#FD4E4E" v-if="props.row.isInspect==0">未检测</div>
						<div style="color:#18A44C" v-if="props.row.isInspect==1">已检测</div>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="150">
					<template slot-scope="props">
						<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
						<div style="color:#FD4E4E" v-else>未支付</div>
					</template>
				</el-table-column>
				<el-table-column label="备注" width="200" prop="remark">
				</el-table-column>
			</el-table>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				msg:{},
				tableData:[],
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getGoodsMsg(this.curItem.recordId)
				this.getList(this.curItem.recordId)
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			// 获取商品信息
			getGoodsMsg(recordId) {
				let loading = this.$loading()
				this.$http.get('/api/Registration/Detail', {
					recordId: recordId
				}).then(res=>{
					loading.close();
					if(res.code===0){
						this.msg = res.data;
					}
				})
			},
			getList(recordId){
				let params = {
					"departmentId":'', 
					"petId": '', 
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					"desc": false, // true  倒序  false 正序
					registrationRecordId:recordId,
					"begin_time": "",
					"end_time": "",
					"pageIndex": 1,
					"pageSize": 100,
					"keyword": ''
				}
				this.$http.post('/api/Case/List', params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.data||[];
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			
		}
		.row{
			padding:14px 20px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;
			.label{
				display: inline-block;width:90px;text-align: right;
			}
		}
	}
	
</style>
